import React, { useEffect, useRef, useState } from 'react';
import { bool, string } from 'prop-types';
import { FinancingDetails } from './FinancingDetails';
import { clickEvent, loadEvent } from '../publisher';
import { loadEstimatorScript } from '../utils';
import './payment-estimator.style.scss';

export const PaymentEstimator = ({ fileVersion, mobile, price }) => {
  const modalRef = useRef({});
  const [displayModal, setDisplayModal] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);

  const handleClickOutside = (event) => {
    if (!modalRef.current) return;

    if (!modalRef.current.contains(event.target) && displayModal) {
      setDisplayModal(false);
      setClicked(false);
    }
  };

  function updatePaymentDetails(isMobile) {
    const estimator = window && window.THD ? (window.THD || {}).PaymentEstimator : null;
    if (!estimator) {
      return;
    }
    const { currentPromotionDates, estimatedPayments, paymentEstimatorApplynowLinks, toolTipText } = estimator;
    const { monthlyPayment, promotionTerm } = estimatedPayments ? estimatedPayments(price) : {};
    const { promoStartDate, promoEndDate } = currentPromotionDates ? currentPromotionDates() : {};
    const { mobileUrl, desktopUrl } = paymentEstimatorApplynowLinks ? paymentEstimatorApplynowLinks('pip') : {};
    const tooltipText = toolTipText ? toolTipText() : null;
    let details = {};

    if (window.THD && window.THD.PaymentEstimator) {
      details = {
        displayPrice: monthlyPayment,
        promotionTerm,
        applyNowUrl: isMobile ? mobileUrl : desktopUrl,
        activeStartDate: promoStartDate,
        activeEndDate: promoEndDate,
        tooltipText
      };
    }
    setPaymentDetails(details);
  }

  useEffect(() => {
    if (window && window.document) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    loadEvent('plcc-est');
    loadEstimatorScript(fileVersion, updatePaymentDetails, mobile);

    return function cleanup() {
      setPaymentDetails(null);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [price]);

  if (!paymentDetails) {
    return null;
  }

  const {
    activeEndDate, activeStartDate, applyNowUrl, displayPrice, promotionTerm, tooltipText
  } = paymentDetails;

  const handleHoverDisplay = () => {
    if (clicked) {
      return;
    }
    setDisplayModal(!displayModal);
  };

  const handleClickDisplay = () => {
    setDisplayModal(true);
    setClicked(!clicked);
  };

  return (
    <div className="buybox-credit-promo-message payment-estimator-wrapper">
      <div className="payment-estimator-separator-wrapper">
        <hr className="payment-estimator-separator-spacing" />
        <span className="payment-estimator-separator">OR</span>
      </div>
      <div className="payment-estimator-message">
        <span className="monthly-payment">
          <span className="monthly-payment-currency-cents">$</span>
          <span className="monthly-payment-price">{displayPrice}</span>
          <span className="monthly-payment-currency-cents">00</span>
        </span>
        <div>
          <div className="payment-estimator-text">
            <span className="u__bold">per month* suggested payments </span>
            with {promotionTerm} months* financing on this
            ${price} purchase*
            <div className="u__inline credit-info-icon-wrapper" ref={modalRef}>
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <span
                onClick={handleClickDisplay}
                onKeyDown={handleClickDisplay}
                onMouseEnter={handleHoverDisplay}
                onMouseLeave={handleHoverDisplay}
                role="button"
                tabIndex={0}
                id="credit-info-icon"
                className="credit-info-icon"
              />
              {displayModal
              && (
                <div className="financing-details">
                  <div className="info-arrow" />
                  <FinancingDetails
                    price={price}
                    monthlyPayment={displayPrice}
                    promotionTerm={promotionTerm}
                    promoStartDate={activeStartDate}
                    promoEndDate={activeEndDate}
                    tooltipText={tooltipText}
                  />
                </div>
              )}
            </div>
            {(!!activeStartDate)
            && (
              <>
                <br />
                VALID: {activeStartDate} - {activeEndDate}
              </>
            )}
          </div>
          <div className="apply-now-link">
            <a
              href={applyNowUrl}
              id="credit-promo-apply-now"
              className="u__default-link"
              target="blank"
              onClick={() => clickEvent('plcc-est')}
            >
              Apply for a Home Depot Consumer Card
            </a>
          </div>
        </div>
      </div>
    </div>

  );
};

PaymentEstimator.displayName = 'PaymentEstimator';

PaymentEstimator.propTypes = {
  fileVersion: string.isRequired,
  mobile: bool,
  price: string.isRequired
};

PaymentEstimator.defaultProps = {
  mobile: false
};
